<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1 class="text">{{this.$route.meta.title}}</h1>
            </div>

            <div class="section-body">
                <div class="row">
                    <div class="col-12 text-center mt-3" v-if="no_data === null">
                        <div class="half-circle-spinner">
                            <div class="circle circle-1"></div>
                            <div class="circle circle-2"></div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === false">
                        <div class="card bdr-15" >
                            <div class="card-header border-0 pb-4 tb-card">
                                <div class="table-sorting">
                                    <div class="table-search float-left">
                                        <vue-search 
                                            :search="sorting"
                                            @searchdata="getDistributors()">
                                        </vue-search>
                                    </div>

                                    <div class="tabel-action float-right">
                                        <button type="submit" v-b-modal.modal-Distributors class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Distributor</button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive bdr-15">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="all_id" v-model="selectAll">
                                                        <label class="custom-control-label" for="all_id"></label>
                                                    </div>
                                                </th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Status</th>
                                                <th>Created Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="tr-ac" v-for="data in distributors.data" :key="data.id" v-on:click="editDistributors(data)">
                                                <td width="100px" v-on:click.stop=""> 
                                                    <div class="custom-control custom-checkbox" v-if="data.id !== 1">
                                                        <input type="checkbox" class="custom-control-input" v-model="del_distributors" :value="data.id" :id="data.id">
                                                        <label class="custom-control-label" :for="data.id"></label>
                                                    </div>
                                                </td>
                                                <td>{{data.name}}</td>
                                                <td>{{data.email}}</td>
                                                <th>
                                                    <label v-if="data.is_active === 'true'" class="badge badge-success"><i class="uil uil-check"></i> Active</label>
                                                    <label v-if="data.is_active === 'false'" class="badge badge-danger"><i class="uil uil-times"></i> Not Active</label>
                                                </th>
                                                <td>{{data.created_at | formatDate}}</td>
                                            </tr>
                                        
                                        </tbody>
                                        
                                    </table>
                                    <p v-if="distributors.total === 0" class="text-center no-data">Distributors data not found</p>
                                </div>
                            </div>
                            <div class="card-footer">
                                <vue-pagination :pagination="distributors"
                                                :sorting="sorting"
                                                @paginate="getDistributors()">
                                </vue-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === true && sorting.search === ''">
                        <div class="card bdr-15">
                            <div class="card-body card-nitem text-center">
                                <img class="mb-5" src="@/assets/img/no-data.svg" alt="">
                                <div class="nitem-desc">
                                    <h2>Distributors Data Still Empty</h2>
                                    <p>On this page you can create distributors user</p>
                                    <div class="tabel-action">
                                        <button type="submit" v-b-modal.modal-Distributors class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Distributors</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-action ca-big" v-if="del_distributors.length !== 0">
                <div class="card-body">
                    <div class="float-left text-white mt-1">
                        <span v-on:click.prevent="del_distributors = []" class="times"><i class="uil uil-times"></i></span>
                        <span><span class="badge">{{del_distributors.length}}</span> distributors selected</span>
                    </div>
                    <div class="float-right">
                        <div v-b-modal.modal-Status class="btn btn-grey mr-2">
                            <i class="uil uil-sync"></i> Status
                        </div>
                        <div v-on:click.prevent="alertDeleteDistributors()" class="btn btn-danger">
                            <i class="uil uil-times"></i> Delete
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <modal-form :del_distributors="del_distributors" @getDistributors="getDistributors(),del_distributors = []"></modal-form>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import VuePagination from "@/components/Pagination.vue";
    import VueSearch from "@/components/Search.vue";
    import ModalForm from '../distributor/ModalForm.vue'
    import moment from 'moment'

    export default {
        name: "distributors",
        components: {
            VuePagination,
            VueSearch,
            ModalForm
        },
        data(){
            return {
                del_distributors:[],
                no_data: null,
            }
        },
        mounted(){
            this.title = this.$route.meta.title;
            this.getDistributors().then(() => {
                if(this.distributors.total == 0){
                    this.no_data = true
                }else{
                    this.no_data = false
                }
            })
        },
        filters: {
            formatDate: function(val){
                if(val){
                    return moment(String(val)).format('DD MMMM YYYY')
                }else{
                    return '-'
                }
            },
        },
        computed:{
            ...mapState('DistributorsControl', {
                distributors: state => state.distributors,
                sorting: state => state.sorting
            }),
            selectAll: {
                get: function () {
                    return this.distributors.data ? this.del_distributors.length == this.distributors.data.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.distributors.data.forEach(function (distributors) {
                            if(distributors.id !== 1){
                                selected.push(distributors.id);
                            }
                        });
                    }

                    this.del_distributors = selected;
                }
            }
        },
        methods: {
            ...mapActions('DistributorsControl', ['getDistributors','deleteDistributors']),
            ...mapMutations('DistributorsControl', ['CLEAR_DISTRIBUTORS','ASSIGN_FORM']),
            
            editDistributors:function(data){
                this.ASSIGN_FORM(data)
                this.$bvModal.show('modal-Distributors')
            },
            alertDeleteDistributors:function(){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this distributor data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deleteDistributors(this.del_distributors).then(
                            this.$toast.success('Successfully Deleting Distributor'),
                            this.del_distributors = []
                        )
                    }
                })
            },
        },
        destroyed(){
            this.CLEAR_DISTRIBUTORS()
        }
    };

</script>
